export const FAQ_MIN_QUESTION_LENGTH = 3;
export const FAQ_MAX_QUESTION_LENGTH = 150;
export const FAQ_MAX_ANSWER_LENGTH = 4;
